// extracted by mini-css-extract-plugin
export default {"reports-component-container":"Reports__reports-component-container___CWNvX","load-error":"Reports__load-error___T1bNC"};